
/* Selectors */
// event verification
export const getSendingOTPState = state => state.eventverification.isSendingOTP;
export const getVerifyingOTPState = state => state.eventverification.isVerifyingOTP;
export const getUserPhoneNotEditableState = state => state.eventverification.isUserPhoneNotEditable;
export const getUpdatingPhoneState = state => state.eventverification.isUpdatingPhone;
export const getOTPSentState = state => state.eventverification.isOTPSent;
export const getVendorHaveUsCallYouSuccesModal = state => state.eventverification.isShowVendorHaveUsCallYouSuccess;
